import { render, staticRenderFns } from "./tabSetupFirstPay.vue?vue&type=template&id=6e140007&"
import script from "./tabSetupFirstPay.vue?vue&type=script&lang=js&"
export * from "./tabSetupFirstPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports